import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { z } from "zod";
import { useTranslation } from "react-i18next";

const filterC5PdfPageSelectionSchema = z.object({
  client_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  page_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_view_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  tableau_workbook_id_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterC5PdfPageSelectionSchema = z.infer<
  typeof filterC5PdfPageSelectionSchema
>;
const filterC5PdfPageSelectionFields =
  filterC5PdfPageSelectionSchema.keyof().enum;

const client = Clients.C5;

export function C5PdfPageSelectionFilter() {
  const { t } = useTranslation("tables");
  const fields: Field[] = [
    {
      name: filterC5PdfPageSelectionFields.client_contains,
      label: t("c5_pdf_page_selection.searchbox.client_contains", { defaultValue: "Client" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.C5}/${Tables.C5_PDF_PAGE_SELECTION}`,
      column_name: "client",
    },
    {
      name: filterC5PdfPageSelectionFields.page_name_contains,
      label: t("c5_pdf_page_selection.searchbox.page_name_contains", { defaultValue: "Page name" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.C5}/${Tables.C5_PDF_PAGE_SELECTION}`,
      column_name: "page_name",
    },
    {
      name: filterC5PdfPageSelectionFields.tableau_view_contains,
      label: t("c5_pdf_page_selection.searchbox.tableau_view_contains", { defaultValue: "Tableau view" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.C5}/${Tables.C5_PDF_PAGE_SELECTION}`,
      column_name: "tableau_view",
    },
    {
      name: filterC5PdfPageSelectionFields.tableau_workbook_id_contains,
      label: t("c5_pdf_page_selection.searchbox.tableau_workbook_id_contains", { defaultValue: "Tableau workbook ID" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.C5}/${Tables.C5_PDF_PAGE_SELECTION}`,
      column_name: "tableau_workbook_id",
    },
    {
      name: "created_at",
      type: "dateRange",
      label: t("c5_pdf_page_selection.searchbox.created_at", { defaultValue: "Creation date" }),
      from: { name: filterC5PdfPageSelectionFields.created_at_from },
      to: { name: filterC5PdfPageSelectionFields.created_at_to },
    },
  ];
  return (
    <FilterTable
      client={client}
      schema={filterC5PdfPageSelectionSchema}
      tableName={Tables.C5_PDF_PAGE_SELECTION}
      fields={fields}
    />
  );
}
